import { Select } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AllergenType } from "../gql/generated/graphqlSchema.tsx";
import { useOptionsWithCurrent } from "../hooks/useOptionsWithCurrent.ts";

type AllergenMultiSelectProps = {
  readonly id?: string;
  readonly value: readonly AllergenType[];
  readonly onChange: (next: AllergenType[]) => void;
  readonly placeholder?: string;
};

export const AllergenMultiSelect = ({
  id = undefined,
  value,
  onChange,
  placeholder = undefined,
}: AllergenMultiSelectProps) => {
  const { t, i18n } = useTranslation();

  const allergens = useMemo(
    () =>
      Object.values(AllergenType).sort((a, b) => t(`allergens.${a}`).localeCompare(t(`allergens.${b}`), i18n.language)),
    [t, i18n.language],
  );

  const options = useOptionsWithCurrent(allergens, null, (key) => ({
    value: key,
    label: t(`allergens.${key}`),
  }));

  return (
    <Select<AllergenType[]>
      allowClear
      id={id}
      mode="multiple"
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      showSearch={{
        filterOption: (input, option) => {
          const label = String(option?.label ?? "").toLocaleLowerCase(i18n.language);
          return label.includes(input.toLocaleLowerCase(i18n.language));
        },
      }}
      value={[...value]}
    />
  );
};
